// extracted by mini-css-extract-plugin
module.exports = {"recentlyViewedproduct":"RecentlyViewedProduct-module__recentlyViewedproduct___Fg0dO"};